import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { ComponentBase } from '../../../../../core/_infrastructure/classes/componentBase';
import { UntypedFormBuilder } from '@angular/forms';
import { Table } from 'primeng/table';
import { Dialog } from 'primeng/dialog';
import { EquipamientoExViewModel } from '../../../productos/productosEx.types';

@Component({
    selector: 'app-matricula-precinto-popup',
    templateUrl: './matriculaPrecintoPopup.component.html',
})
export class MatriculaPrecintoPopupComponent extends ComponentBase implements OnInit {
    @ViewChild('tableSearch') turboTable: Table;
    @Output() selected = new EventEmitter<EquipamientoExViewModel>();

    display = false;
    cols: any[];
    selectedMatriculaPrecinto: any;
    editTitle = 'Nuevo';
    isCollapsed = false;

    constructor(private fb: UntypedFormBuilder) {
        super();
    }

    ngOnInit() {
        this.createForm();

        //this.cols = [
        //    { field: 'Id', header: 'Id', display: 'none' },
        //    { field: 'IdSolicitudEx', header: 'IdSolicitudEx', display: 'none' },
        //    { field: 'Matricula', header: 'Matrí­cula' },
        //    { field: 'Precinto', header: 'Precinto' }
        //];

        //this.Search(0);
    }

    createForm(): void {
        this.form = this.fb.group({
            Matricula: '',
            Precinto: '',
        });
    }

    updateForm(equipamiento: any): void {
        this.form.patchValue({
            Matricula: equipamiento.Matricula,
            Precinto: equipamiento.Precinto,
        });
    }

    showDialog(idSolicitudEx: number, equipamiento: any | null): void {
        this.display = true;
        this.selectedMatriculaPrecinto = new Object();
        //edicion
        if (equipamiento != null) {
            this.editTitle = 'Editar';
            this.selectedMatriculaPrecinto = equipamiento;
            this.updateForm(equipamiento);
        }
        //alta
        else {
            this.selectedMatriculaPrecinto.IdSolicitudEx = idSolicitudEx;
            this.updateForm(this.selectedMatriculaPrecinto);
        }
    }

    //onRowDblClick(event: any, partidaPredua: TPartidaPreduaViewModel) {
    //    this.display = false;

    //    this.selectedEmitter.emit(partidaPredua);
    //}

    aceptDialog(): void {
        this.display = false;

        this.selectedMatriculaPrecinto.Matricula = this.form.value.Matricula;
        this.selectedMatriculaPrecinto.Precinto = this.form.value.Precinto;
        this.selectedMatriculaPrecinto.Inspeccion = false;
        //let object: any = this.selectedMatriculaPrecinto;

        this.selected.emit(this.selectedMatriculaPrecinto);
    }

    cancelDialog(): void {
        this.display = false;
    }

    showDialogMaximized(dialog: Dialog): void {
        setTimeout(() => {
            dialog.maximize();
        }, 0);
    }
}
